export default __webpack_public_path__ + "static/media/Guaranteed-Saving-Star-Brochure.98a1b009.pdf";